<div class="main">
  <div *ngIf="valuesOk; else badValues" class="tags">
    <div class="tag energy">
      <span class="label-top">logement extrêmement performant</span>
      <span class="label-bottom">logement extrêmement peu performant</span>
      <span *ngIf="showLabelBad" class="label-bad">passoire<br>énergétique</span>
      <div class="values {{energyTagClass}}">
        <div class="energy">
          <span class="label">consommation</span>
          <span class="label-bis">(énergie primaire)</span>
          <span class="value">{{energyValue}} </span>
          <span class="unit">kWh/m²/an</span>
        </div>
        <div class="ges">
          <span class="label">émissions</span>
          <span class="value">{{gesValue}} *</span>
          <span class="unit">kgCO₂/m²/an</span>
        </div>
      </div>
      <img [src]="energyTagImg" alt="Consommations énergétiques">
    </div>
    <div class="tag ges">
      <span class="label-asterisk">* Dont émissions de gaz<br>à effet de serre</span>
      <span class="label-top">peu d'émissions de CO₂</span>
      <span class="label-bottom">émissions de CO₂<br>très importantes</span>
      <div class="values {{gesTagClass}}">
        <span class="value">{{gesValue}}</span>
        <span class="unit">kgCO₂/m²/an</span>
      </div>
      <img [src]="gesTagImg" alt="Emissions de gaz à effet de serre">
    </div>
  </div>
  <div class="copyright">
    <span class="text-muted">&copy; Ademe</span>
  </div>
</div>

<ng-template #badValues>
  <span class="no-content dark">Renseignez les indices de consommation et d'émission et les classifications associées
    pour visualiser le DPE</span>
</ng-template>